// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".demo-table-expand[data-v-43952a2d]{font-size:0}.demo-table-expand .el-form-item[data-v-43952a2d]{margin-right:0;margin-bottom:0;width:100%}.demo-table-expand .el-form-item[data-v-43952a2d]  .el-form-item__label{width:120px;color:#99a9bf}.el-dropdown-link[data-v-43952a2d]{cursor:pointer}.el-icon-s-operation[data-v-43952a2d]{font-size:24px}", ""]);
// Exports
module.exports = exports;
